const styles = theme => {
  const minMd = theme.breakpoints.up('md');

  return {
    actionsRow: {
      display: 'flex',
      marginTop: 20,
      width: '100%',
      [minMd]: {
        marginTop: 30,
      },
    },
    roleSelectContain: {
      display: 'flex',
    },
    closeButton: {
      marginRight: 10,
    },
    nextButton: {
      flexGrow: 1,
    },
    formGroup: {
      marginTop: 20,
      [minMd]: {
        marginTop: 30,
      },
      '&:first-child': {
        marginTop: 0,
      },
    },
    hiddenInput: {
      display: 'none',
    },
  };
};

export default styles;
